import { useMobile } from '@amili-v3/amili-v3-design/src/hooks/useMobile';
import { PropsWithChildren } from 'react';
import { NavbarProps } from '../../interfaces';
import MobileNavbar, { MobileNavbarProps } from '../MobileNavbar';
import {
  NavChildrenContainer,
  NavContainer,
  NavSeparator,
  NavbarWrapper,
} from './styles';

const Navbar = (props: PropsWithChildren & NavbarProps & MobileNavbarProps) => {
  const isMobile = useMobile();
  const {
    left,
    right,
    title,
    backHref,
    subElement,
    leftCustomStyle,
    rightCustomStyle,
    navCustomStyle,
  } = props;

  return isMobile ? (
    <MobileNavbar backHref={backHref} title={title} subElement={subElement} />
  ) : (
    <NavbarWrapper className={navCustomStyle}>
      <NavContainer>
        <NavChildrenContainer className={leftCustomStyle}>
          {left?.map((item, index) => {
            return (
              <NavChildrenContainer key={index}>
                {item}
                {index !== left.length - 1 && !!left[index + 1] && (
                  <NavSeparator />
                )}
              </NavChildrenContainer>
            );
          })}
        </NavChildrenContainer>

        <NavChildrenContainer className={rightCustomStyle}>
          {right?.map((item, index) => {
            return (
              <NavChildrenContainer key={index}>
                {item}
                {index !== right.length - 1 && !!right[index + 1] && item && (
                  <NavSeparator />
                )}
              </NavChildrenContainer>
            );
          })}
        </NavChildrenContainer>
      </NavContainer>
    </NavbarWrapper>
  );
};

export default Navbar;
